<template>
  <v-card class="props">
    <v-card-title> Редактирование слайда </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <template v-for="(strings, field) in imageFields">
          <v-file-input
            :key="field"
            accept="image/*"
            :label="strings.label"
            :hint="strings.hint"
            persistent-hint
            @change="store(field, arguments[0])"
          />
          <img
            v-if="mergedData[field]"
            :key="field + 'Img'"
            width="100%"
            :src="mergedData[field]"
            :alt="strings.label"
          />
        </template>
        <v-file-input
          accept="image/*"
          label="Изображение"
          hint="231×137"
          persistent-hint
          @change="store('image', arguments[0])"
        />
        <div class="slideImage" v-if="mergedData.image">
          <img width="100%" :src="mergedData.image" alt="Изображение" />
        </div>
        <v-checkbox
          v-model="mergedData.remove_image"
          label="Убрать изображение"
        ></v-checkbox>
        <v-text-field
          v-for="(label, sign) in langs"
          :key="`title_${sign}`"
          v-model="mergedData['title_' + sign]"
          :label="`Заголовок (${label})`"
          :rules="rules.title"
        />
        <v-textarea
          v-for="(label, sign) in langs"
          :key="`text_${sign}`"
          v-model="mergedData['text_' + sign]"
          :label="`Текст (${label})`"
          :rules="rules.text"
        />
        <v-checkbox
          v-model="mergedData.is_published"
          label="Показывать на сайте"
        ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text color="light-green darken-4" @click="save"> Сохранить </v-btn>
    </v-card-actions>
    <snackbar v-bind.sync="snackbar" />
  </v-card>
</template>

<script>
import Snackbar from "../Snackbar";
import transport from "../../mixins/transport";
import readBase64 from "../../mixins/readBase64";

export default {
  name: "SliderProps",
  components: { Snackbar },
  mixins: [transport, readBase64],
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      imageDesktop: "",
      imageMobile: "",
      imageFields: {
        desktop: { label: "Десктопная версия", hint: "1440×403" },
        mobile: { label: "Мобильная версия", hint: "1500×750" }
      },
      langs: {
        ru: "рус.",
        kk: "каз.",
        en: "англ."
      },
      mergedData: Object.assign({ remove_image: false }, this.data),
      errors: [],
      rules: {
        title: [
          (v) => !v || v.length < 255 || "не более 255 символов"
        ],
        text: [(v) => !!v || "Заполните поле"]
      },
      valid: true
    };
  },
  watch: {
    data: {
      handler() {
        this.mergedData = Object.assign({ remove_image: false }, this.data);
      }
    }
  },
  methods: {
    imagesValidate() {
      return Object.keys(this.imageFields).every((field) => {
        if (!this.mergedData[field]) {
          this.errorSnack(
            `Загрузите изображение ("${this.imageFields[field]}")`
          );
          return false;
        }
        return true;
      });
    },
    store(fieldName, file) {
      this.readBase64(file).then((stringData) => {
        this.$set(this.mergedData, fieldName, stringData);
      });
    },
    save() {
      this.$refs.form.validate();
      if (!this.valid || !this.imagesValidate()) return;
      this.exchange(
        (data) => {
          if (this.mergedData.id !== data.activeSlide.id)
            this.$emit("updateAll", data.slides, data.activeSlide);
          else this.$emit("updateSlide", data.activeSlide);
        },
        this.mergedData,
        "slider",
        "post",
        "сохранено"
      );
    }
  }
};
</script>
<style lang="scss">
.slideImage {
  padding: 10px;
  background: url("/assets/images/opacity.png");
}
</style>
